// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AA5Yfsd7nWQwUI3tTEWE {
	display: flex;
	flex-direction: column;
	position: relative;
}
@media not all and (max-width: 767px) {
.AA5Yfsd7nWQwUI3tTEWE {
		justify-content: center;
		padding-bottom: 50px;
}
	}
.nQ5xAOoOodO9pV4Qn6Av {
	padding: 0 32px 32px 32px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ClaimRewardsPage/RewardsPage.pcss"],"names":[],"mappings":"AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,kBAAkB;AAMnB;AAJC;AALD;EAME,uBAAuB;EACvB,oBAAoB;AAEtB;CADC;AAGD;CACC,yBAAyB;AAC1B","sourcesContent":["@import './../../stylesheets/media-queries.pcss';\n\n.page {\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n\n\t@media not all and (--mobile) {\n\t\tjustify-content: center;\n\t\tpadding-bottom: 50px;\n\t}\n}\n\n.bannerListContainer {\n\tpadding: 0 32px 32px 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AA5Yfsd7nWQwUI3tTEWE`,
	"bannerListContainer": `nQ5xAOoOodO9pV4Qn6Av`
};
export default ___CSS_LOADER_EXPORT___;
